export default __webpack_public_path__ + "static/media/p1_m.aff4c28a.png";